import { Typography, Card, CardContent, Box } from "@mui/material";


const PageTerm = () => {

    return (
        <Card>
            <CardContent>
                <Box>

                    <Typography align='center' variant="h4" sx={{ mb: 2 }}>
                        ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ (ПУБЛИЧНАЯ ОФЕРТА)
                    </Typography>

                    <Typography align='center' sx={{ mb: 2 }}>
                        Настоящее Пользовательское соглашение (далее — «Соглашение») является
                        публичной офертой и регулирует отношения между ИП Герасименко Николай
                        Николаевич (далее — «Сервис») и пользователем сети Интернет (далее —
                        «Пользователь»).
                    </Typography>

                    <Typography align='center' sx={{ mb: 4 }}>
                        Используя сайт https://www.gamecointrader.space/, Пользователь
                        подтверждает, что ознакомился и принимает условия настоящего Соглашения.
                    </Typography>

                    <Typography variant="h6" align='center' sx={{ mt: 3, mb: 2 }}>
                        1. Общие положения
                    </Typography>

                    <Typography align='justify' paragraph>
                        1.1. Сервис предоставляет услуги по организации безопасных сделок между
                        пользователями в сфере цифровых услуг и виртуальных товаров.
                    </Typography>

                    <Typography align='justify' paragraph>
                        1.2. Сервис не является продавцом товаров, а выступает посредником.
                    </Typography>

                    <Typography align='justify' paragraph>
                        1.3. Пользователь обязуется использовать сайт только в законных целях.
                    </Typography>

                    <Typography variant="h6" align='center' sx={{ mt: 3, mb: 2 }}>
                        2. Предмет соглашения
                    </Typography>

                    <Typography align='justify' paragraph>
                        2.1. Сервис предоставляет платформу для:
                    </Typography>

                    <Box component="ul" sx={{ pl: 4, mb: 2 }}>
                        <li>
                            <Typography>покупки и продажи цифровых услуг</Typography>
                        </li>
                        <li>
                            <Typography>проведения безопасных сделок</Typography>
                        </li>
                        <li>
                            <Typography>перевода средств</Typography>
                        </li>
                    </Box>

                    <Typography align='justify' paragraph>
                        2.2. Все товары являются цифровыми.
                    </Typography>

                    <Typography align='justify' paragraph>
                        2.3. Доставка осуществляется в электронном виде.
                    </Typography>

                    <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
                        2.4. Характер услуг
                    </Typography>

                    <Typography align='justify' paragraph>
                        Сервис предоставляет услуги по организации безопасных сделок, включая:
                    </Typography>

                    <Box component="ul" sx={{ pl: 4, mb: 2 }}>
                        <li>
                            <Typography>внутриигровые услуги</Typography>
                        </li>
                        <li>
                            <Typography>передачу игровых ресурсов</Typography>
                        </li>
                        <li>
                            <Typography>выполнение игровых заданий</Typography>
                        </li>
                    </Box>

                    <Typography align='justify' paragraph>
                        Сервис не продаёт игровые ценности напрямую.
                    </Typography>

                    <Typography variant="h6" align='center' sx={{ mt: 3, mb: 2 }}>
                        3. Порядок оплаты
                    </Typography>

                    <Typography align='justify' paragraph>
                        3.1. Оплата осуществляется через доступные платёжные системы.
                    </Typography>

                    <Typography align='justify' paragraph>
                        3.2. Средства могут удерживаться до завершения сделки.
                    </Typography>

                    <Typography align='justify' paragraph>
                        3.3. После выполнения сделки средства переводятся второй стороне за
                        вычетом комиссии Сервиса.
                    </Typography>

                    <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
                        3.4. Момент оказания услуги
                    </Typography>

                    <Typography align='justify' paragraph>
                        Услуга считается оказанной с момента передачи цифрового товара.
                    </Typography>

                    <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
                        3.5. Валюта расчетов
                    </Typography>

                    <Typography align='justify' paragraph>
                        Все цены указаны в рублях Российской Федерации (RUB).
                    </Typography>
                    <Typography align='justify' paragraph>
                        3.6 Сервис вправе удерживать вознаграждение за предоставленные услуги. Размер вознаграждения, порядок его расчета и сторона, с которой оно удерживается, определяются настоящей офертой и информацией, размещенной на Сайте.
                    </Typography>
                    <Typography align='justify' paragraph>
                        3.7 За предоставление услуг по организации сделки, обработке заявки, обеспечению расчетов и техническому сопровождению исполнения сделки Сервис удерживает с Продавца вознаграждение в размере 10% от суммы сделки. Указанное вознаграждение удерживается Сервисом при перечислении денежных средств Продавцу.
                    </Typography>
                    <Typography variant="h6" align='center' sx={{ mt: 3, mb: 2 }}>
                        4. Возврат средств
                    </Typography>

                    <Typography align='justify' paragraph>
                        4.1. Возврат возможен только в случае:
                    </Typography>

                    <Box component="ul" sx={{ pl: 4, mb: 2 }}>
                        <li>
                            <Typography>невыполнения обязательств</Typography>
                        </li>
                        <li>
                            <Typography>технической ошибки</Typography>
                        </li>
                        <li>
                            <Typography>отмены сделки</Typography>
                        </li>
                    </Box>

                    <Typography align='justify' paragraph>
                        4.2. Возврат невозможен после передачи цифрового товара.
                    </Typography>

                    <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
                        4.3. Порядок рассмотрения споров
                    </Typography>

                    <Typography align='justify' paragraph>
                        Пользователь вправе направить претензию на email:
                        nik.gerasimenko1995@mail.ru
                    </Typography>

                    <Typography align='justify' paragraph>
                        Срок рассмотрения — до 5 рабочих дней.
                    </Typography>

                    <Typography variant="h6" align='center' sx={{ mt: 3, mb: 2 }}>
                        5. Ответственность сторон
                    </Typography>

                    <Typography align='justify' paragraph>
                        5.1. Сервис не несёт ответственности за действия пользователей.
                    </Typography>

                    <Typography align='justify' paragraph>
                        5.2. Пользователь несёт ответственность за законность действий.
                    </Typography>

                    <Typography align='justify' paragraph>
                        5.3. Сервис не является правообладателем игровых продуктов. Все
                        товарные знаки принадлежат их владельцам.
                    </Typography>

                    <Typography align='justify' paragraph>
                        5.4. Запрещено использование Сервиса для:
                    </Typography>

                    <Box component="ul" sx={{ pl: 4, mb: 2 }}>
                        <li>
                            <Typography>мошенничества</Typography>
                        </li>
                        <li>
                            <Typography>отмывания денежных средств</Typography>
                        </li>
                        <li>
                            <Typography>незаконной деятельности</Typography>
                        </li>
                    </Box>

                    <Typography align='justify' paragraph>
                        5.5. Сервис вправе приостанавливать операции при подозрении на
                        нарушения.
                    </Typography>

                    <Typography align='justify' paragraph>
                        5.6. Сервис вправе запросить идентификацию пользователя.
                    </Typography>

                    <Typography variant="h6" align='center' sx={{ mt: 3, mb: 2 }}>
                        6. Ограничение ответственности
                    </Typography>

                    <Typography align='justify' paragraph>
                        6.1. Сервис не гарантирует бесперебойную работу сайта.
                    </Typography>

                    <Typography align='justify' paragraph>
                        6.2. Сервис не несёт ответственности за возможные убытки.
                    </Typography>

                    <Typography variant="h6" align='center' sx={{ mt: 3, mb: 2 }}>
                        7. Персональные данные
                    </Typography>

                    <Typography align='justify' paragraph>
                        7.1. Пользователь даёт согласие на обработку персональных данных.
                    </Typography>

                    <Typography align='justify' paragraph>
                        7.2. Политика конфиденциальности является неотъемлемой частью
                        Соглашения.
                    </Typography>

                    <Typography variant="h6" align='center' sx={{ mt: 3, mb: 2 }}>
                        8. Изменение условий
                    </Typography>

                    <Typography align='justify' paragraph>
                        8.1. Сервис вправе изменять условия без уведомления.
                    </Typography>

                    <Typography variant="h6" align='center' sx={{ mt: 3, mb: 2 }}>
                        9. Контактная информация
                    </Typography>

                    <Typography align='justify' paragraph>
                        ИП Герасименко Николай Николаевич
                        <br />
                        Регистрационный номер: ИП-01-2026-299
                        <br />
                        ИНН: 9000091261
                        <br />
                        Адрес: г. Тирасполь, ул. Ленина, д. 10, кв. 5
                        <br />
                        Телефон: +373 779 18542
                        <br />
                        Email: nik.gerasimenko1995@mail.ru
                    </Typography>

                    <Typography variant="h6" align='center' sx={{ mt: 3, mb: 2 }}>
                        10. Заключительные положения
                    </Typography>

                    <Typography align='justify' paragraph>
                        10.1. Настоящее Соглашение является публичной офертой.
                    </Typography>

                    <Typography align='justify' paragraph>
                        10.2. Использование сайта означает согласие с условиями.
                    </Typography>

                    <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
                        10.3. Применимое право
                    </Typography>

                    <Typography align='justify' paragraph>
                        К отношениям сторон применяется законодательство по месту регистрации
                        Сервиса.
                    </Typography>

                    <Typography variant="h6" align='center' sx={{ mt: 3, mb: 2 }}>
                        11. Акцепт оферты
                    </Typography>

                    <Typography align='justify' paragraph>
                        11.1. Акцептом настоящей оферты считается:
                    </Typography>

                    <Box component="ul" sx={{ pl: 4, mb: 2 }}>
                        <li>
                            <Typography>регистрация на сайте</Typography>
                        </li>
                        <li>
                            <Typography>оформление заказа</Typography>
                        </li>
                        <li>
                            <Typography>оплата услуг</Typography>
                        </li>
                    </Box>

                    <Typography align='justify' paragraph>
                        11.2. С момента акцепта договор считается заключенным.
                    </Typography>





                </Box>
            </CardContent>
        </Card>
    )

}

export default PageTerm;


